import React, { memo } from 'react';
import cn from 'classnames';

import { ArrowProps } from './types';
import styles from './Arrow.module.scss';

export const Arrow = memo(function Arrow({ onClick, type }: ArrowProps) {
  return <div className={cn(styles.main, styles[`main_type_${type}`])} onClick={onClick} />;
});
